export default __webpack_public_path__ + "static/media/clock.3a579b3f.svg";